module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baruch")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Narrative and Prayer of Repentance (1:1–3:8)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Activity in Babylon (1:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preliminaries (1:10–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Letter: Early Sins (1:14–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continued Sins and Punishments (2:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Deliverance (2:11–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Mercy (2:27–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Plea (3:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Praise and Desirability of Wisdom (3:9–4:4)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Poetry of Consolation (4:5–5:9)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basis for Courage (4:5–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Address to Zion (4:30–5:9)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Letter of Jeremiah")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Letter (6:1–73)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additions to Daniel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on the Prayer of Azariah")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Detailed Comments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on the Song of the Three Jews")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on Susanna")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on Bel and the Dragon")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prayer of Manasseh")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch3-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch3-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History of the Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch3-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure, Genre, and Text")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch3-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetoric and Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch3-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch3-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise (vv. 1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch3-s7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgment of God’s Mercy (vv. 5–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch3-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confession (vv. 8–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch3-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supplication (vv. 11–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch3-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch3-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Statement of Trust and Praise (vv. 14–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 151")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch4-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch4-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch4-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superscription")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch4-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verse 1")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch4-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verse 2")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch4-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verse 3")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch4-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verse 4")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch4-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verse 5")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch4-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verses 6–7")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch4-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch4-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 151 as a Whole")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "back"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/back#back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get the Complete Commentary!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0